/**
 * cognitiveQuietingEngine.js — FASE R7.
 *
 * Detects when too many layers are simultaneously trying to shape the response
 * and produces a suppression instruction to reduce analytical density.
 *
 * When fired, it tells Kevia to stop covering all angles and speak from one place.
 *
 * Max output: 70 chars. Natural pastoral Spanish. No technical labels.
 */

const QUIETING_INSTRUCTIONS = {
  strong:   "Menos análisis. Más presencia.",
  moderate: "Responde desde lo central.",
  light:    "No cubras todos los ángulos.",
};

/**
 * @param {{
 *   activeBlockCount: number,
 *   signalCount:      number,
 *   loadLevel:        string,
 *   refinementActive: boolean,
 *   rhythmProfile:    string|null,
 * }} params
 * @returns {{
 *   shouldQuiet:      boolean,
 *   suppressionLevel: "none"|"light"|"moderate"|"strong",
 *   instruction:      string|null,
 * }}
 */
export function buildCognitiveQuieting({ activeBlockCount = 0, signalCount = 0, loadLevel = "low", refinementActive = false, rhythmProfile = null }) {
  // Strong quieting: many simultaneous blocks + high load
  if (activeBlockCount >= 6 || loadLevel === "high") {
    return { shouldQuiet: true, suppressionLevel: "strong", instruction: QUIETING_INSTRUCTIONS.strong };
  }

  // Moderate quieting: restrained/sparse rhythm already active (deep grief/exhaustion)
  if (rhythmProfile === "restrained" || rhythmProfile === "sparse" || rhythmProfile === "compact") {
    return { shouldQuiet: true, suppressionLevel: "moderate", instruction: QUIETING_INSTRUCTIONS.moderate };
  }

  // Light quieting: too many signals active even if no single layer is overloaded
  if (activeBlockCount >= 4 || signalCount >= 5 || (refinementActive && signalCount >= 3)) {
    return { shouldQuiet: true, suppressionLevel: "light", instruction: QUIETING_INSTRUCTIONS.light };
  }

  return { shouldQuiet: false, suppressionLevel: "none", instruction: null };
}
